/* eslint-disable react/prop-types */
/*
Author: Granite Bagas
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';

import ForecastStockScreen from '@/screens/setting/forecast-stock/ForecastStockScreen';
import ForecastStockDetailScreen from '@/screens/setting/forecast-stock/ForecastStockDetailScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const ForecastStockNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="ForecastStockScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="ForecastStockScreen"
        component={ForecastStockScreen}
        options={(props) => ({
          title: setTitleHeader('Forecast Stock'),
          headerRight: () => <NotificationSettingButton {...props} />,
        })}
      />
      <Stack.Screen
        name="ForecastStockDetailScreen"
        component={ForecastStockDetailScreen}
        options={(props) => ({
          title: setTitleHeader(props?.route?.params?.title),
        })}
      />
    </Stack.Navigator>
  );
};

export default ForecastStockNavigator;
